import collect from "collect.js";
import provinceSrc from "./china-division/provinces.json";
import citySrc from "./china-division/cities.json";
import areas from "./china-division/areas.json";

const generateOptions = (flag) => {
  const provinces = JSON.parse(JSON.stringify(provinceSrc));
  const cities = JSON.parse(JSON.stringify(citySrc));
  const staticProvinces = provinces;
  const provinceLists = provinces.map((provincesItem) => {
    return provincesItem.list;
  });
  const allProvinces = collect(provinceLists).collapse().all(); // 原始省数组，不含key

  if (!cities[0].children) {
    areas.forEach((area) => {
      let matchCity = cities.filter((city) => city.code === area.cityCode)[0];
      if (!flag) {
        matchCity = null;
      }
      if (matchCity) {
        matchCity.children = matchCity.children || [];
        matchCity.children.push({
          label: area.name,
          value: area.code,
        });
      }
    });
  }
  if (!allProvinces[0].children) {
    cities.forEach((city) => {
      const matchProvince = allProvinces.filter(
        (province) => province.code === city.provinceCode,
      )[0];
      if (matchProvince) {
        matchProvince.children = matchProvince.children || [];
        matchProvince.children.push({
          label: city.name,
          value: city.code,
          children: flag ? city.children : null, // &&functionTools.sortChinese(city.children)
        });
      }
    });
  }

  // 字母组索引--start
  const flatedArr = [];
  for (const item of staticProvinces) {
    const itemArray = item.list;
    const options = itemArray.map((province) => {
      // allProvinces.map()

      return {
        label: province.name,
        // disabled:province.disabled,
        // className:'cad-title',//后添
        // firstLetter:getFUpper(province.name),//城市首字母索引
        value: province.code,
        children: province.children, // && functionTools.sortChinese(province.children)
      };
    });

    const arr = [
      {
        label: item.key,
        value: item.key,
        disabled: true,
        className: "cad-title",
      },
      ...options,
    ];
    flatedArr.push(...arr);
  }
  // 字母组索引--end
  // const options = flatedArr.map(province => {//allProvinces.map()
  //
  // return {
  // label:province.name,
  // disabled:province.disabled,
  // className:'cad-title',//后添
  // // firstLetter:getFUpper(province.name),//城市首字母索引
  // value:province.code,
  // children:province.children,// && functionTools.sortChinese(province.children)
  // }
  // });
  // let sortedProvinces=functionTools.sortChinese(options);//排序后的省
  // let collection=collect(sortedProvinces)
  // let groups=collection.groupBy('firstLetter').all();//分组后的省对象{A:[{},{}],B:[{}]}
  // let flatedArr=[];
  // let filterGroups=JSON.parse(JSON.stringify(groups));//过滤后的省对象{A:{items:[{},{}]}}
  // for(let item in options){
  // let itemArray=filterGroups[item].items;
  // let arr=[{
  // label:item,
  // value:item,
  // disabled:true
  // },...itemArray]
  // flatedArr.push(...arr)
  // }

  return flatedArr;
};

export default generateOptions;



// WEBPACK FOOTER //
// ./src/AntD/components/dataEntry/areaPickerOption.js